import {MenuCard, MenuCardProps} from "components/index";
import {MenuItem, Typography} from "@mui/material";
import {FileStatus} from "enums/fileStatus";

interface FilterStatusMenuProps extends MenuCardProps {
  onClick: (status: string) => void
}

function FilterStatusMenu(props: FilterStatusMenuProps) {
  const {anchorEl, open, closeMenu, onClick} = props;

  let statusValues = ["All"];
  Object.keys(FileStatus).forEach(key => statusValues.push(key));

  return (
    <>
      <MenuCard anchorEl={anchorEl} open={open} closeMenu={closeMenu}>
        {
          statusValues.map(status =>
            (<MenuItem
              value={status}
              id={`file-requirement-overview-filter-status-${status}`}
              key={`file-requirement-overview-filter-status-${status}`}
              onClick={() => onClick(status)}
            >
              <Typography variant="body">{status}</Typography>
            </MenuItem>)
          )
        }
      </MenuCard>
    </>
  )
}

export default FilterStatusMenu;